// extracted by mini-css-extract-plugin
module.exports = {"marker-container":"attention-marker_marker-container__gG1Wq","marker-pulse":"attention-marker_marker-pulse__BvKfw","pulsate":"attention-marker_pulsate__rvBRg"};